import { render, staticRenderFns } from "./FerramentasView.vue?vue&type=template&id=4055c90d&"
import script from "./FerramentasView.vue?vue&type=script&lang=js&"
export * from "./FerramentasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports